import { API, Card, CheckBox, Explination, Input, Select, Submit, ViewHeader } from '@enkla-gui'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { Divider } from 'antd'
import { notify } from '@/_helpers'
import { useForm } from 'react-hook-form'

export default function EntityEdit() {
  const { register, handleSubmit, reset, watch, getValues, setValue } = useForm(false)
  const [error, setError] = useState(null)
  const [entity, setEntity] = useState(null)
  const [sending, setSending] = useState(false)
  const [types, setTypes] = useState(null)
  const { id } = useParams()
  const history = useHistory()

  useEffect(() => {
    API.get(`api/entity/types`).then(types => setTypes(types))
    API.get(`api/entity/${id}`).then(entity => {
      reset(entity)
      setEntity(entity)
    })
  }, [id, reset])

  const onSubmit = data => {
    setSending(true)
    API.patch('api/entity', data)
      .then(res => {
        notify.toast('Ändringar sparade')
        setError(null)
        setSending(false)
        history.push(`/entity/${id}`)
      })
      .catch(([err, res]) => {
        setError({
          message: res.message,
          data: res.data
        })
        setSending(false)
      })
  }

  const printTypeFields = () => {
    if (types === null) return
    var aet = types.filter(e => e.id === entity?.entity_type_id)[0]
    var output = []
    var orderedFields = []

    for (let [key, value] of Object.entries(aet?.fields || [])) {
      orderedFields.push({
        key: key,
        value: value
      })
    }
    if (aet?.rentable) {
      output.push(
        <>
          <div className='col-12'><Divider size='small' /></div>
          <div class='col-6'>
            <Input tip='Hur fungerar hyran på ett objekt?' controls={{ register }} name='fee' options={{ required: false }} label={`Hyra (exmoms) per ${{ 'MONTHLY': 'månad', 'QUARTERLY': 'kvartal', 'YEARLY': 'år', 'NONE': 'betalningsintervall' }[watch('payment_interval') || 'NONE']}`} type='number' error={error} />
          </div>
          <Select
            controls={{ register }}
            name='payment_interval'
            options={{ required: false }}
            label='Betalningsintervall'
            cols='col-6 mb-3'
            values={[
              { key: 'Månadsvis', value: 'MONTHLY' },
              { key: 'Kvartalsvis', value: 'QUARTERLY' },
              { key: 'Årligen', value: 'YEARLY' }
            ]}
          />
          <div class='col-6'>
            <div class='form-group mb-3'>
              <label>
                Pris per m2 <Explination tip='Vad betyder pris per m2?' />
              </label>
              <br />
              <CheckBox label='Pris per m2' controls={{ register, getValues, setValue }} name={`fee_as_m2`} options={{ required: false }} label={'Pris per m2'} />
              {(!!watch('fee_as_m2') || !!getValues('fee_as_m2')) && (
                <div style={{ fontSize: '12px', color: '#7E8299', marginTop: '4px' }}>
                  {watch('fields.area') && parseFloat(watch('fields.area')) > 0 ? (
                    <span>
                      Hyra per {{ 'MONTHLY': 'månad', 'QUARTERLY': 'kvartal', 'YEARLY': 'år', 'NONE': 'betalningsintervall' }[watch('payment_interval') || 'NONE']}: {
                        (parseFloat(watch('fee') || 0) * parseFloat(watch('fields.area') || 0)).toLocaleString('sv-SE', { style: 'currency', currency: 'SEK' })
                      }
                    </span>
                  ) : (
                    <span>Förhandsvisning av hyra visas efter att area har fyllts i</span>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className='col-12'><Divider size='small' /></div>
        </>
      )
    }

    for (let { key, value } of orderedFields) {
      switch (value.type) {
        case 'string':
        case 'number':
          output.push(
            <Input
              error={error}
              controls={{ register }}
              name={`fields.${key}`}
              options={{ required: false }}
              label={value.title}
              type={value.type}
              cols='col-6 mb-3'
            />
          )
          break
        case 'boolean':
          output.push(
            <div class='col-6'>
              <div class='form-group mb-3'>
                <label>{value.title}</label>
                <br />
                <CheckBox error={error} controls={{ register, getValues, setValue }} name={`fields.${key}`} options={{ required: false }} label={value.title} />
              </div>
            </div>
          )
          break
        case 'list':
          output.push(
            <Select
              error={error}
              controls={{ register }}
              name={`fields.${key}`}
              options={{ required: false }}
              label={value.title}
              cols='col-6 mb-3'
              values={value.options.map((option, x) => {
                return {
                  key: option,
                  value: option
                }
              })}
            />
          )
          break
        default:
          break
      }
    }
    return output
  }

  return (
    <>
      <ViewHeader
        loading={!watch('id')}
        title='Objekt'
        icon='fa-layer-group'
        subtitle='Redigera'
        return={{ link: `#!/entity/${id}`, title: getValues('name') }}
        buttons={[{ icon: 'fa-times', title: 'Avbryt', href: `#!/entity/${id}`, position: 'right' }]}
      />
      <Card
        loading={!watch('id')}
        buttons={{
          footer: [<Submit onSubmit={handleSubmit(onSubmit)} text='Spara' sending={sending} />]
        }}>
        <div class='row mb-3'>
          <Input controls={{ register }} name='name' options={{ required: true }} label='Namn' error={error} />
          <Input controls={{ register }} name='reference' options={{ required: false }} label='Objektsreferens' error={error} />
        </div>
        <div class='row mb-3'>
          <Input controls={{ register }} name='address' options={{ required: false }} label='Adress' error={error} />
          <Input controls={{ register }} name='postal_code' options={{ required: false }} label='Postnummer' error={error} />
        </div>
        <div class='row mb-3'>
          <Input controls={{ register }} name='city' options={{ required: false }} label='Stad' error={error} />
          <Select
            controls={{ register }}
            name='country'
            options={{ required: false }}
            label='Land'
            error={error}
            preset="countries"
          />
        </div>
        <div class='row'>{printTypeFields()}</div>
      </Card>
    </>
  )
}
